
export const QuizTopicsData = [
    {
        Title: 'Concept of Science Project-22',
        image: 'https://s3-alpha-sig.figma.com/img/dd99/0ef8/258777c2b20dbe2313d754fa7f0c8eb5?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=FtoG-tScqExpbG5OJ-OT-77dIH6l83zlaWoVGMMTVBOOYCj6mf7fl2FMziXBzR4Z1g9z8Ehg6FFzDyFMzsCoMMqfHhMvLkej6WoqFQynOkDZOJsj03qt1BdsAY8dRGHVA-O85M6ku9IQqMNPlTBjFJ-Nx7KKQO3uar3VxUakX30nLTu0cww-uJYK1tJLHwWBbUZjFINhzHJEcy9V~kVHtWY~nAdk6GSq4-cKYkL7sUK8s32zR-zBeCGGDrvy-J9lJtdigfjHFDyiV~LpXMLhSB7-7JHMT1yoqt4RNOXjIjNJVLjOLNdMNHEeB7K7Qf9dxkI-rKk3-npN~VOIheieYQ__',
    },
    {
        Title: 'Concept of English Grammer',
        image: 'https://s3-alpha-sig.figma.com/img/dd99/0ef8/258777c2b20dbe2313d754fa7f0c8eb5?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=FtoG-tScqExpbG5OJ-OT-77dIH6l83zlaWoVGMMTVBOOYCj6mf7fl2FMziXBzR4Z1g9z8Ehg6FFzDyFMzsCoMMqfHhMvLkej6WoqFQynOkDZOJsj03qt1BdsAY8dRGHVA-O85M6ku9IQqMNPlTBjFJ-Nx7KKQO3uar3VxUakX30nLTu0cww-uJYK1tJLHwWBbUZjFINhzHJEcy9V~kVHtWY~nAdk6GSq4-cKYkL7sUK8s32zR-zBeCGGDrvy-J9lJtdigfjHFDyiV~LpXMLhSB7-7JHMT1yoqt4RNOXjIjNJVLjOLNdMNHEeB7K7Qf9dxkI-rKk3-npN~VOIheieYQ__',
    },
    {
        Title: 'Concept of Maths structure and Algorithm',
        image: 'https://s3-alpha-sig.figma.com/img/dd99/0ef8/258777c2b20dbe2313d754fa7f0c8eb5?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=FtoG-tScqExpbG5OJ-OT-77dIH6l83zlaWoVGMMTVBOOYCj6mf7fl2FMziXBzR4Z1g9z8Ehg6FFzDyFMzsCoMMqfHhMvLkej6WoqFQynOkDZOJsj03qt1BdsAY8dRGHVA-O85M6ku9IQqMNPlTBjFJ-Nx7KKQO3uar3VxUakX30nLTu0cww-uJYK1tJLHwWBbUZjFINhzHJEcy9V~kVHtWY~nAdk6GSq4-cKYkL7sUK8s32zR-zBeCGGDrvy-J9lJtdigfjHFDyiV~LpXMLhSB7-7JHMT1yoqt4RNOXjIjNJVLjOLNdMNHEeB7K7Qf9dxkI-rKk3-npN~VOIheieYQ__',
    },
    {
        Title: 'Concept for data science concept',
        image: 'https://s3-alpha-sig.figma.com/img/dd99/0ef8/258777c2b20dbe2313d754fa7f0c8eb5?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=FtoG-tScqExpbG5OJ-OT-77dIH6l83zlaWoVGMMTVBOOYCj6mf7fl2FMziXBzR4Z1g9z8Ehg6FFzDyFMzsCoMMqfHhMvLkej6WoqFQynOkDZOJsj03qt1BdsAY8dRGHVA-O85M6ku9IQqMNPlTBjFJ-Nx7KKQO3uar3VxUakX30nLTu0cww-uJYK1tJLHwWBbUZjFINhzHJEcy9V~kVHtWY~nAdk6GSq4-cKYkL7sUK8s32zR-zBeCGGDrvy-J9lJtdigfjHFDyiV~LpXMLhSB7-7JHMT1yoqt4RNOXjIjNJVLjOLNdMNHEeB7K7Qf9dxkI-rKk3-npN~VOIheieYQ__',
    },
    {
        Title: 'Concept of Data Science Concept',
        image: 'https://s3-alpha-sig.figma.com/img/dd99/0ef8/258777c2b20dbe2313d754fa7f0c8eb5?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=FtoG-tScqExpbG5OJ-OT-77dIH6l83zlaWoVGMMTVBOOYCj6mf7fl2FMziXBzR4Z1g9z8Ehg6FFzDyFMzsCoMMqfHhMvLkej6WoqFQynOkDZOJsj03qt1BdsAY8dRGHVA-O85M6ku9IQqMNPlTBjFJ-Nx7KKQO3uar3VxUakX30nLTu0cww-uJYK1tJLHwWBbUZjFINhzHJEcy9V~kVHtWY~nAdk6GSq4-cKYkL7sUK8s32zR-zBeCGGDrvy-J9lJtdigfjHFDyiV~LpXMLhSB7-7JHMT1yoqt4RNOXjIjNJVLjOLNdMNHEeB7K7Qf9dxkI-rKk3-npN~VOIheieYQ__',
    },
    {
        Title: 'Concept of English Grammatical structure',
        image: 'https://s3-alpha-sig.figma.com/img/dd99/0ef8/258777c2b20dbe2313d754fa7f0c8eb5?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=FtoG-tScqExpbG5OJ-OT-77dIH6l83zlaWoVGMMTVBOOYCj6mf7fl2FMziXBzR4Z1g9z8Ehg6FFzDyFMzsCoMMqfHhMvLkej6WoqFQynOkDZOJsj03qt1BdsAY8dRGHVA-O85M6ku9IQqMNPlTBjFJ-Nx7KKQO3uar3VxUakX30nLTu0cww-uJYK1tJLHwWBbUZjFINhzHJEcy9V~kVHtWY~nAdk6GSq4-cKYkL7sUK8s32zR-zBeCGGDrvy-J9lJtdigfjHFDyiV~LpXMLhSB7-7JHMT1yoqt4RNOXjIjNJVLjOLNdMNHEeB7K7Qf9dxkI-rKk3-npN~VOIheieYQ__',
    },
];

export const SubjectsData = [
    {
        image: 'https://s3-alpha-sig.figma.com/img/627d/2bb5/978e9e9e32b372e2ae4e558cebec038c?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=pMm-5~5L4I51pWdsOGSe44a6WjMcwH89J2q~wFRFn9ZqfxcD4MUSZPYgUAL~9240X3By074~8F8jrOssgaQcCTzD4ibWjrICR2Tq42Zxe~cClm9g4B4EMDhS~TTWZHKIMXQlYwTRIDWDoyWa-hwbXfVlLfHN6H74r9-PfL1ySJGQe8IE36-diQkZQOAlDQxx-EKBKbf~aKDLawX88CsSdfVtFteBwg2r25m9z6Ktz1LMxoJRfZ0NvRzPI11shhBp~SQ33M7VMbLaGEPU0vyrXtdrW59tszYPEg-H2W1Q71SMe1C~IDut3~twIubWI1fpMJpVhkRRvSyd97rWUDT4DA__',
        Title: 'Biology',
    },
    {
        image: 'https://s3-alpha-sig.figma.com/img/7ae7/a1c2/a783f8b60568e8b787fd351157e82fdf?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=brQ4Vb--mtmtFGlE4K8q9lIXPZnGR56-pthvEGcQbPHRadqsEH4vh6PeUCSSyRvQn2cRVIyTI1il7XiJeUh7FURYMgDnSDnNgYcQv8lbc02GnSedujVZE3TCqjoj-4Z~8v6QlS5Muoaf5QwudTqB2C0C8swH94MM0YDU4NVJlomUyv3NTYgQdY7EXErU1KG3X4LGXRo6ZGbaMPiG3al2AOmIfLKYqBCUmE4ffjwAei5TkFCjMqWGqIYZwNa12EB-2qUVw1gV3HspjQ3AFmrNHp05XrahorYdNcSoprCstglFG9krgdfP43Lh2FiDPSl1EXWtu5y~e~WuYzTY823TIA__',
        Title: 'Physics',
    },
    {
        image: 'https://s3-alpha-sig.figma.com/img/ed10/5bbe/84a739cc2e26943d997047d3b726ecfa?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=mX-ZUMq86-xrOxoULY1ya9JExR59Rgacq648sm6YxpKvQ6j4OC3hi8wZ53mC45vWRtyeCZZ~Mny8HhY~s5L~kXeXmxbWt5YdGqchhKj2vkvFyrExlug3dyTAhIF7KqVdqCiAC9rd5xGwEsn0PrjaNMbV3GI9cOcGxxOSd63~v9V2EbOVxWsLc3kM4BPb1U9K36K~ccr976-BwKNejF-EtG8VxWQaFcLdJaczyu3njBxyTvUW-cfRHX6uIw9xdsoSKRQ3QFMWNUkwCKzSgG6LRZ7azoDppI50w4Pi0Enu5uMpHSmNRrnddSA6Gpp5cGnq9efswPe1kUjxsFga1g-49w__',
        Title: 'Maths',
    },
    {
        image: 'https://s3-alpha-sig.figma.com/img/9b7b/3cfc/cdd53b219db65695c8afad4a9bcf913f?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=lB~sclBlmrBKQ3VvVO0b45Z8dTVbRzypfAI0mJIv0Wtvt3zIRfTgTTielvx2i5u--s1LhbRzoOp2Kqp~RLfxlnxNO992~jPV7mA9pX8wAjk0FLKUoishpRg9h373isx7H69GTWBT2W1YuhVFdHRtONzl3QJ-WIzAk~dQu2GPonaYq5Uqz03nzQIehOainQ6iD61CJ0Bhs2pS4l4LHdBMXLuvYD2RdCuTxqi-GW0vJWUdvYzngJCFLEIwStDow4sEudL1muGulQti6An0dIp4-~1wwLomYHZ91qLmO-n5EYFfMT4G04JxHizd7uZA0s9ZUvcQNtCRZFLLk8~49USlKQ__',
        Title: 'Chemistry',
    },
    {
        image: 'https://s3-alpha-sig.figma.com/img/3cf7/89c5/095b48b943d2dd26e8f236dc95544cec?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=RJyDaRes5To9~WLkLeGF6fhSo5CsuJfoyDMP0ms1wcODYe4w9phM22k7EM~rUtr2S5LrL~Ufu4twKbWj2~ve91g7JHdaAnb5wFTQ6l9fkN43jVc2X55eHXXR8Olg1dGaFzPpwR3eMGEi1i9PG4zUGoJRP290R3ndvmHrV8X4OujRGBNp26hH3XCaG7bJmogc1zRv0dxwa5PtcWX5cKzehAe11KBAVWCdqjEnCQh3pgSV5L2ykJjPaEJOYLcAuIjDhCVAIazKRo0hc8c-8IVdENDVYZl3EXE-o~U-o1Vkhcf1VsUPxPNQJagnBrt6ptAXPD9Vp4ikEEkJzkFB07wWOg__',
        Title: 'English',
    },
    {
        image: 'https://s3-alpha-sig.figma.com/img/4994/59d4/6999761854d1c647f9d53ec36e3cefe3?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ljpbXTCmBD7jCzKrG0T3dxygaBWtiK5fAG73Lc-DcM3Ff6MoAUa8OUdT52u7XoMtBs7apdAOb4JMwsDe0zdcAy30hUio80U3mpvVM51MwCEvt1I5e2xfqSirhoKfh4KW7RqNGVku8gbR0a6-yxCkjgA8H9CcYZRNiJ2EVDTZFi3~PB0E9k58HgzC4PCO5z0wQbJw8MGJPqYA1Gu6ZendAZPfgXZwhHCgaSLMG673aJlTQvsKG1uqTLG9ttVL4iGT5WE4gMdsWWfyPuy~Uq2eDrq-cf0KGVjHgQd6ped~vsUG7YCjpz66tcxp-XJJrT72EW6uH3O2cPjWTSv9rQEFgg__',
        Title: 'Social Studies',
    }
];

export const WelcomeStudentImagesArray = [
    require('../../images/students/slider1.png'),
    require('../../images/students/slider2.png'),
    require('../../images/students/slider3.png'),
];

export const CompletionData = [
    {
        Title: 'Quiz',
        Chapter: 'Chapter 3',
        percentage: 1,
    },
    {
        Title: 'Puzzle Game',
        Chapter: 'Chapter 3',
        percentage: 100,
    },
    {
        Title: 'Quiz',
        Chapter: 'Chapter 1',
        percentage: 45,
    },
    {
        Title: 'Quiz',
        Chapter: 'Chapter 3',
        percentage: 75,
    },

];

export const TopPerformers = [
    {
        Title: 'Darlene Robertson',
        Points: 9.6,
    },
    {
        Title: 'Wade Warren',
        Points: 9,
    },
    {
        Title: 'Savannah Nguyen',
        Points: 9,
    },
    {
        Title: 'Courtney Henry',
        Points: 8.5,
    },
];

export const TimelineData = [
    {
        Title: 'Quiz # 01',
        Class: 'Class 5th',
        Time: '10: 00 AM',
    },
    {
        Title: 'Puzzle Game',
        Class: 'Class 5th',
        Time: '08: 00 AM',
    },

];
